import { render } from "./SideBarComp.vue?vue&type=template&id=941c1b80&scoped=true"
import script from "./SideBarComp.vue?vue&type=script&lang=js"
export * from "./SideBarComp.vue?vue&type=script&lang=js"

import "./SideBarComp.vue?vue&type=style&index=0&id=941c1b80&scoped=true&lang=css"

import exportComponent from "G:\\deploy\\cfan\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-941c1b80"]])

export default __exports__